import { useContext } from 'react';
import { SSEProvider } from './sse-provider';

export const useSSE = () => {
  const context = useContext(SSEProvider.SSEContext);

  if (!context) {
    throw new Error('useSSE must be used within a SSEProvider');
  }

  return context;
};
